import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import * as anatomy from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(anatomy.inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    padding: 0,
    fontSize: 'md',
    fontWeight: 400,
    lineHeight: '22px',
    height: '24px',
    color: 'black.500',
    fontFamily: '"Poppins", sans-serif',
    fontSmoothing: 'antialiased',
    marginTop: 0,
    _placeholder: {
      color: 'neutral.400',
    },
    _focus: {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  variants: {
    unstyled: {
      field: {
        border: '0px solid',
        borderColor: 'blue',
        height: '24px',
      },
    },
  },
});

export const Input = defineMultiStyleConfig({
  ...baseStyle,
  defaultProps: {
    variant: 'unstyled',
  },
});
